export const ChargeCategory = {
    SYS: 'SYS',
    GEN: 'GEN',
    USER: 'USER'
}